import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: true,
  actionsLoading: false,
  totalCount: 0,
  lastError: null,
  error: null,
  settings: null,
  fields: [],
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const companySettingsSlice = createSlice({
  name: "companySettings",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    comapanySettingsFetched: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.settings = action.payload.settings;
      state.error = null;
    },

    comapanySettingsFieldFetched: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.fields = action.payload.fields;
      state.error = null;
    },
  },
});
